import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';
import { Button } from './ui/button';
import Logo from './Logo';
import { companyInfo } from '../data/mock';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'About Us', path: '/about' },
    { name: 'Why Us', path: '/why-us' },
    { name: 'Services', path: '/services' },
    { name: 'Calculators', path: '/calculators' },
    { name: 'Testimonials', path: '/testimonials' },
    { name: 'Contact', path: '/contact' }
  ];

  const handleWhatsApp = () => {
    window.open(companyInfo.whatsappLink, '_blank');
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-[#0f1419] shadow-xl shadow-black/30 border-b border-gray-800' : 'bg-[#0f1419]/95 backdrop-blur-md'
      }`}
    >
      <div className="container mx-auto px-4 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <Logo />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-5 py-2.5 text-[17px] font-medium transition-all rounded-lg ${
                  location.pathname === link.path
                    ? 'text-[#F59E0B] bg-[#F59E0B]/10'
                    : 'text-gray-300 hover:text-[#F59E0B] hover:bg-[#F59E0B]/5'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </nav>

          {/* CTA Button */}
          <div className="hidden lg:flex items-center">
            <Button
              onClick={handleWhatsApp}
              className="bg-gradient-to-r from-[#F59E0B] to-[#FBBF24] hover:from-[#D97706] hover:to-[#F59E0B] text-black font-semibold px-7 py-6 text-[17px] shadow-lg shadow-[#F59E0B]/30 transition-all"
            >
              <Phone className="w-5 h-5 mr-2" />
              Talk to an Expert
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden p-2 text-gray-300 hover:text-[#F59E0B] transition-colors"
          >
            {isMobileMenuOpen ? <X className="w-7 h-7" /> : <Menu className="w-7 h-7" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden py-4 border-t border-gray-800">
            <nav className="flex flex-col space-y-2">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => setIsMobileMenuOpen(false)}
                  className={`px-4 py-3 text-[17px] font-medium transition-all rounded-lg ${
                    location.pathname === link.path
                      ? 'text-[#F59E0B] bg-[#F59E0B]/10'
                      : 'text-gray-300 hover:text-[#F59E0B] hover:bg-[#F59E0B]/5'
                  }`}
                >
                  {link.name}
                </Link>
              ))}
              <Button
                onClick={handleWhatsApp}
                className="bg-gradient-to-r from-[#F59E0B] to-[#FBBF24] hover:from-[#D97706] hover:to-[#F59E0B] text-black font-semibold mx-4 mt-2"
              >
                <Phone className="w-4 h-4 mr-2" />
                Talk to an Expert
              </Button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
